import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@uzurv/core';

export interface ModalLink {
  text: string;
  handler?: (value?: any) => boolean | void | { [key: string]: any };
}

export interface ModalButton {
  text: string;
  role?: string;
  handler?: (value?: any) => boolean | void | { [key: string]: any };
}

export interface AlertDialogData {
  svgIcon?: string;
  title: string;
  message: string;
  links?: Array<ModalLink>;
  buttons?: Array<ModalButton>;
}

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: AlertDialogData, private dialogRef: MatDialogRef<AlertDialogComponent>) {
    // TODO: Refactor Alert Dialog calls to use data.svgIcon instead of data.title === 'Error'.
    if (data?.title === 'Error' && isNullOrUndefined(data?.svgIcon)) {
      data.svgIcon = 'uz-alert-circle-outline';
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
